import { post } from '../utils';

export const exchangeToken = (payload: { token: string }) => {
    return post('/token/exchange', {
        body: payload,
        headers: {},
    }) as Promise<{ token: string }>;
};
